import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "@/components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import AccordionColumnBox from "@/components/AccordionColumnBox";

export default function CandidateFAQPage({ global, faqItems }) {
  return (
    <>
      <SeoHead
        page_name={`Candidate FAQs | Project engineering and technical recruitment specialists | Carbon60`}
        canonical_link={`about-us/candidate-faqs`}
      />
      <MainBanner
        global={global}
        pathPrefix={`candidate_faqs_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Candidate FAQ</h1>
            <p>
              Are you a candidate and have a question for us? Check below for
              our frequently asked questions for our top candidate enquiries to
              streamline the job application process for all candidates. From
              application updates to locked accounts, you can find your answer
              here.
            </p>
          </>
        }
        displayImage1={false}
        backgroundImage={'/site-assets/images/abstract-4.png'}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
      />

      <AccordionColumnBox
        global={global}
        pathPrefix="candidate_faq_page.faq_section"
        customClass="my-5"
        post={faqItems}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const faqItem = await Collection('frequently_asked_question');
  const faqItems = faqItem.getItems();

  return {
    props: {
      global,
      faqItems,
    },
  };
}
